"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _UnsubscribeForm = _interopRequireDefault(require("./UnsubscribeForm"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Unsubscribe = function Unsubscribe(_ref) {
  var loadData = _ref.loadData;
  return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: "Unsubscribe",
    trigger: /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      type: "button",
      className: "btn btn-primary",
      title: "Unsubscribe"
    })
  }, /*#__PURE__*/_react["default"].createElement(_UnsubscribeForm["default"], {
    loadData: loadData
  }));
};
var _default = exports["default"] = Unsubscribe;